import Vue from "vue";
import Constructionstage from "./constructionstage"


export const constructionstageinit = {
    init: () => {
        const constructionstageShells = document.querySelectorAll('.constructionstage');
        constructionstageShells.forEach(shell => {
            const configurationName = shell.dataset.configuration
            if (!configurationName || !window[configurationName] || typeof window[configurationName] !== 'object') {
                return
            }

            new Vue({
                render: h => h(Constructionstage, {
                    props: {
                        configuration: window[configurationName]
                    }
                })
            }).$mount(shell);
        });
    }
};
